export const GenerateThresholdClass = (thresholdValue, value) => {
  if (value >= thresholdValue)
    return 'bg-warning text-danger';
  else if (value < 0)
    return 'bg-danger text-white';
};
